// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__ho5DS","buttons":"SendReceipts_buttons__2kcLv","email":"SendReceipts_email__TmYqV","bookApptTitle":"SendReceipts_bookApptTitle__1sKzD"};